import React, { useEffect, useState } from "react";
import {
  deleteKbDetailsAPI,
  getCustomKbAPI,
  publishDetailsAPI,
  updateDetailsAPI,
} from "./utils/constants";
import "./customKA.css";
import EditDetails from "./popups/editDetails";
import { useTheme } from "@mui/material";
import { useKBState } from "./customHooks/useKBState";
import ErrorPopup from "./popups/errorPopup";

type KBItem = {
  create_date: string;
  number: string;
  kb_text: string;
};

const itemsPerPage = 6;

const CustomKASection: React.FC = () => {
  const [kbData, setKbData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [editItem, setEditItem] = useState<KBItem | null>(null);
  const [deleteItem, setDeleteItem] = useState<KBItem | null>(null);
  const [updatedKbText, setUpdatedKbText] = useState("");
  const [loading, setLoading] = useState(false);
  const [deleteloader, setDeleteLoader] = useState(false);
  const [updateCustomKAloader, setUpdateCustomKALoader] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const theme = useTheme();
  const color = theme.palette.mode;
  const { val, setVal } = useKBState();
  const [dropdownVal, setDropdownVal] = useState("KB Number");
  const dropdownOptions = ["KB Number", "KB Content"];

  useEffect(() => {
    getCustomKb();
  }, []);

  const getCustomKb = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("actions", "getCustomKb");
      formData.append("method", "POST");
      formData.append("action", "fetch");

      const options = {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json",
        // },
        // body: JSON.stringify({
        //   "action": "fetch",
        // }),
        body:formData
      };

      const result = await (await fetch(`${getCustomKbAPI}`, options)).json();
      console.log("get custom kb result", result);

      setKbData(Array.isArray(result) ? result : result?.data || []);
    } catch (error) {
      console.error("Error fetching KB:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleShowToast = (value: any, type: any) => {
    setShowToast(true);
    setToastMessage(value);
    setToastType(type);
    setTimeout(() => {
      setShowToast(false);
      setToastMessage("");
      setToastType("");
    }, 4000);
  };

  const filteredData = kbData.filter((item: any) => {
    const value = dropdownVal === "KB Number" ? item.number : item.content;
    return value?.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  let cp = currentPage * 10;
  const lastIndx = cp > filteredData?.length ? filteredData?.length : cp;
  const frstIndx =
    lastIndx % 10 == 0 ? lastIndx - 9 : lastIndx - (lastIndx % 10) + 1;
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const chngePage = async (page: any) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const prevPage = async () => {
    if (currentPage != 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const nxtPage = async () => {
    if (currentPage != totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const renderPageNumbers = (): JSX.Element[] => {
    const pages: any = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(renderPageButton(i));
      }
    } else {
      pages.push(renderPageButton(1));
      if (currentPage > 3) {
        console.log("inside");

        pages.push(
          <li className="page-item disabled" key="start-ellipsis">
            <span className="page-link">...</span>
          </li>
        );
      }

      // const startPage = Math.max(2, currentPage -1);
      // const endPage = Math.min(totalPages - 1, currentPage - 1);
      // console.log('start page, endpage', startPage, endPage);

      const middlePages: number[] = [];
      if (currentPage <= 3) {
        middlePages.push(2, 3, 4);
      } else if (currentPage >= totalPages - 2) {
        middlePages.push(totalPages - 3, totalPages - 2, totalPages - 1);
      } else {
        middlePages.push(currentPage - 1, currentPage, currentPage + 1);
      }

      middlePages.forEach((page) => {
        if (page > 1 && page < totalPages) {
          pages.push(renderPageButton(page));
        }
      });

      if (currentPage < totalPages - 2) {
        pages.push(
          <li className="page-item disabled" key="end-ellipsis">
            <span className="page-link">...</span>
          </li>
        );
      }

      pages.push(renderPageButton(totalPages));
    }

    return pages;
  };

  const renderPageButton = (page: number) => {
    return (
      <li
        key={page}
        className={`page-item ${currentPage === page ? "active" : ""}`}
      >
        <button
          className="page-link"
          style={{ width: "38px" }}
          onClick={() => chngePage(page)}
        >
          {page}
        </button>
      </li>
    );
  };

  const handleEdit = (item: any) => {
    setEditItem(item);
    setUpdatedKbText(item.kb_text);
  };
  const handleDelete = async (item: any) => {
    console.log("delete item", item);
    setDeleteLoader(true);
    try {
      const formData = new FormData();
      formData.append("actions", "delete_kb");
      formData.append("method", "DELETE");
      formData.append("kb_number", item?.number);
      const options = {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json"
        // },
        // body: JSON.stringify({
        //   "kb_number": item?.number
        // }),
        body:formData
      };
      const result = await (
        await fetch(`${deleteKbDetailsAPI}`, options)
      ).json();
      if (result) {
        console.log("get delete kb result", result);
        setDeleteLoader(false);
        setDeleteItem(null);
        handleShowToast(result.message, "danger");
        getCustomKb();
      } else {
      }
    } catch (error) { }
  };

  const handleUpdate = async (item: any) => {
    console.log("edit item", editItem);
    setUpdateCustomKALoader(true);
    const formData = new FormData();
    formData.append("actions", "update_kb");
    formData.append("method", "POST");
    formData.append("kb_number", item?.number);
    formData.append("kbtext", updatedKbText);
    try {
      const options = {
        method: "POST",
        // headers: {
        //   "Content-Type": "application/json"
        // },
        // body: JSON.stringify({
        //   "kb_number": item?.number,
        //   "kbtext": updatedKbText
        // }),
        body:formData
      };
      const result = await (await fetch(`${updateDetailsAPI}`, options)).json();
      if (result) {
        console.log("get custom kb result", result);
        setKbData((prev: any) =>
          prev.map((kb: any) =>
            kb.number === item?.number ? { ...kb, content: updatedKbText } : kb
          )
        );
        setEditItem(null);
        setUpdateCustomKALoader(false);
        handleShowToast(result.success, "success");
      } else {
      }
    } catch (error) { }
  };

  const publishDetails = async () => {
    setVal({ ...val, publishloader: true });

    try {
       const formData = new FormData();
           formData.append("actions", "recreate_index");
           formData.append("method", "GET");
           const options = {
             method: "POST",
             // headers: {
             //   "Content-Type": "application/json",
             // },
             body:formData
           };
     
           const response = await fetch(publishDetailsAPI, options);
     
           console.log("raw response in custom ka", response);
     
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      console.log("get publish details result", result);

      if (result) {
        setVal({
          ...val,
          publishloader: false,
          openPublishPopup: false,
        });

        handleShowToast(result?.message, "success");
      } else {
        alert("Not Found");
        setVal({ ...val, publishloader: false });
      }
    } catch (error) {
      console.error("publishDetails API error:", error);

      setVal({
        ...val,
        publishloader: false,
      });
    }
  };
  
  return (
    <div
     
      style={{
        display: "flex",
        flexDirection: "column",
        height: "-webkit-fill-available",
      }}
    >
      <div
        className="search-box mb-3 positive-relative"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: "40px",
          paddingRight: "40px",
          paddingTop: "20px",

        }}
      >
        <div style={{ display: 'flex', gap: '8px' }}>
          <div className="btn-group" style={{ width: "fit-content",borderColor:"black" }}>
            <button
              className={`btn  dropdown-toggle`}
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ borderColor:"black" }}
            >
              {dropdownVal}
            </button>
            <ul
              className={`dropdown-menu dropdown-menu-primary`}
              style={{ width: "-webkit-fill-available" }}
            >
              {dropdownOptions.map((option) => (
                <li key={option}>
                  <a
                    className={`dropdown-item ${dropdownVal === option ? "active" : ""
                      }`}
                    href="#"
                    onClick={() => setDropdownVal(option)}
                  >
                    {option}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            {/* <i className="bi bi-search position-absolute ms-3 text-muted"></i> */}
            <input
              type="text"
              className="form-control"
              placeholder={`Search by ${dropdownVal}`}
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>


        {!loading && (
          <button
            type="button"
            className="btn btn-success"
            style={{ width: "fit-content" }}
            onClick={() => setVal({ ...val, openPublishPopup: true })}
            disabled={val.publishloader}
          >
            Publish
          </button>
        )}
      </div>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flex: 1,
            height: "100%",
          }}
        >
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : paginatedData.length === 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            height: "100%",
          }}
        >
          <i
            className="bi bi-file-earmark-x"
            style={{ fontSize: "30px" }}
          ></i>
          <p style={{ margin: 0 }}> No Data Found</p>
        </div>
      ) : (
        <div style={{ flex: "1 0 auto", paddingLeft: "40px", paddingRight: "40px" }}>
          <div
            className="rounded-3"
            style={{
              border: "1px solid #ededed",
              overflow: "auto",
            }}
          >
            <table
              style={{ margin: 0 }}
              className="table table-striped table-responsive table-hover"
            >
              <thead
                className={ "table-dark"}
              >
                <tr>
                  <th style={{ whiteSpace: "nowrap", width: "fit-content" }}>
                    S. No
                  </th>
                  <th style={{ whiteSpace: "nowrap", width: "fit-content" }}>
                    Custom KA Number
                  </th>
                  <th style={{ whiteSpace: "nowrap", width: "fit-content" }}>
                    Description
                  </th>
                  <th style={{ whiteSpace: "nowrap", width: "fit-content" }}>
                    Date Created
                  </th>
                  <th
                    style={{ whiteSpace: "nowrap", width: "fit-content" }}
                    className="centered"
                  >
                    Delete
                  </th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item: any, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td className="ka-number">{item.number}</td>
                    <td style={{ minWidth: "450px" }}>
                      <div className="desc-cell">
                        <span className="desc-text">{item.content}</span>
                        <button
                          className="btn icon-btn edit"
                          onClick={() => handleEdit(item)}
                        >
                          <i className="bi bi-pencil-fill"></i>
                        </button>
                      </div>
                    </td>
                    <td>{item.updated_date}</td>
                    <td className="centered">
                      <button
                        className="btn icon-btn delete"
                        onClick={() => setDeleteItem(item)}
                      >
                        <i className="bi bi-trash-fill"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {totalPages > 1 && paginatedData.length > 0 && (
        <nav className="mt-4 d-flex justify-content-end">
          <ul className="pagination" style={{ margin: 0, paddingBottom: "20px", paddingRight: "40px" }}>
            <li className={`page-item ${currentPage == 1 ? "disabled" : ""}`}>
              <button className="btn btn-primary page-link" onClick={prevPage}>
                Previous
              </button>
            </li>

            {renderPageNumbers()}

            <li
              className={`page-item ${currentPage == totalPages ? "disabled" : ""
                }`}
            >
              <button className="btn btn-primary page-link" onClick={nxtPage}>
                Next
              </button>
            </li>
            {/* {[...Array(totalPages)].map((_, idx) => (
              <li
                key={idx}
                className={`page-item ${
                  currentPage === idx + 1 ? "active" : ""
                }`}
              >
                <button
                  className="page-link"
                  style={{ width: "38px" }}
                  onClick={() => setCurrentPage(idx + 1)}
                >
                  {idx + 1}
                </button>
              </li>
            ))} */}
          </ul>
        </nav>
      )}

      {editItem && (
        <EditDetails
          data={editItem}
          onClose={() => setEditItem(null)}
          onUpdate={() => handleUpdate(editItem)}
          setUpdatedKbText={setUpdatedKbText}
          loader={updateCustomKAloader}
          state="update"
        />
      )}

      {val.openPublishPopup && (
        <EditDetails
          onClose={() => setVal({ ...val, openPublishPopup: false })}
          onPublish={publishDetails}
          state="publish"
          loader={val.publishloader}
        />
      )}

      {deleteItem && (
        <div
          className="modal fade show d-block customkb-modal"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-danger">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  Confirm Delete
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDeleteItem(null)}
                ></button>
              </div>
              <div className="modal-body" style={{ margin: 0 }}>
                <div>
                  <p>
                    Are you sure you want to delete{" "}
                    <strong>{deleteItem.number}</strong>.
                  </p>
                </div>
              </div>
              <div className="modal-footer" style={{ justifyContent: "end" }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setDeleteItem(null)}
                >
                  <i className="bi bi-x-circle me-1"></i> Cancel
                </button>
                <button
                  type="button"
                  onClick={() => handleDelete(deleteItem)}
                  className="btn btn-danger"
                  disabled={deleteloader}
                  style={{ pointerEvents: deleteloader ? "none" : "auto" }}
                >
                  {deleteloader && (
                    <div
                      style={{
                        fontSize: "16px",
                        height: "16px",
                        width: "16px",
                        marginRight: "6px",
                      }}
                      className="spinner-border"
                      role="status"
                    ></div>
                  )}
                  <i className="bi bi-trash-fill me-1"></i> Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* bootstrap toast for alert messages       */}
      <div
        className={`toast position-fixed start-50 translate-middle-x align-items-center text-bg-${toastType} border-0 ${showToast ? "show" : "hide"
          } `}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="d-flex">
          <div className="toast-body">{toastMessage}</div>
          <button
            type="button"
            className="btn-close btn-close-white me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
          ></button>
        </div>
      </div>

      {val.showErrorPopup && (
        <ErrorPopup
          message={"Something went wrong"}
          onClose={() => setVal({ ...val, showErrorPopup: false })}
        />
      )}
    </div>
  );
};

export default CustomKASection;
